<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.1719 14.8151C18.9485 14.2038 17.0967 13.8647 16.2922 13.6822C14.9218 13.4781 14.485 13.3434 13.7989 13.9104C13.4804 14.2201 13.2474 14.7173 13.2474 15.1003C13.2474 15.6627 13.7057 16.3637 14.1873 16.5593C14.3038 16.6 16.0902 16.9587 18.1485 17.3417C20.2146 17.7248 21.9467 18.059 22.001 18.0753C22.0554 18.0916 21.6127 20.0966 20.6263 24.2208C19.8262 27.5789 19.1427 30.5049 19.1194 30.7249C19.0883 30.9939 19.2825 32.8849 19.7563 36.8623C20.4864 42.9345 20.502 42.9996 20.9525 43.4398C21.2942 43.774 21.8535 43.9777 22.2962 43.9289C23.0574 43.8474 23.5855 43.4235 23.8574 42.6818L23.9972 42.3069L23.3215 36.6668L22.6535 31.0348L22.8632 30.1543C22.9719 29.6735 23.0884 29.2823 23.1195 29.2823C23.1428 29.2823 25.0768 32.3143 27.4225 36.0229C29.7605 39.7394 31.7877 42.8938 31.9197 43.0405C32.2848 43.4562 32.6654 43.6274 33.1936 43.6274C34.1024 43.6274 34.778 43.065 34.9566 42.1764C35.0966 41.4592 35.1586 41.5652 30.7857 34.678C28.5177 31.1081 26.6458 28.1249 26.6303 28.0516C26.607 27.9782 27.1584 25.6146 27.8497 22.8026C29.2401 17.1461 29.2723 16.8198 29.0969 16.4938C28.9216 16.1677 28.5921 16.2085 28.3235 16.0866C28.0095 16.0047 26.04 15.5486 22.1719 14.8151Z"
            fill="currentColor" />
        <path
            d="M32.6768 3.30316C32.1176 2.4555 31.9933 2.32509 31.6205 2.15392C31.2787 1.99906 30.9137 1.99091 30.5874 2.12947C30.2379 2.28433 16.339 12.0728 16.0128 12.3826L15.3423 12.8716L16.8285 13.1569C17.5565 12.6338 20.0586 10.8578 23.4028 8.54398C27.3019 5.83798 30.5874 3.56397 30.6962 3.48247L31.1589 3.17241L30.9647 3.49843C31.2832 4.3298 31.7059 5.24299 32.0787 5.44675C32.3506 5.59346 32.7467 5.47935 32.972 5.19409C33.3992 4.66431 33.3448 4.29751 32.6768 3.30316Z"
            fill="currentColor" />
        <path
            d="M24.4822 12.1256C24.4822 13.8136 25.7863 15.182 27.3949 15.182C29.0036 15.182 30.3076 13.8136 30.3076 12.1256C30.3076 10.4375 29.0036 9.06912 27.3949 9.06912C25.7863 9.06912 24.4822 10.4375 24.4822 12.1256Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
